exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videos__container__2qYPc{width:100%;height:100%;position:relative}.videos__thumbnail-wrapper__1tnmS{position:relative;overflow:hidden}.videos__next-button__1qqmh,.videos__prev-button__248HZ{background-color:rgba(0,0,0,.8);height:66px;width:50px;margin-top:-33px}.videos__next-button__1qqmh:hover,.videos__prev-button__248HZ:hover{opacity:1}.videos__next-button__1qqmh:hover>svg,.videos__prev-button__248HZ:hover>svg{opacity:1;transition:opacity .3s ease-in-out}.videos__next-button__1qqmh>svg,.videos__prev-button__248HZ>svg{opacity:.5;width:12px;height:24px}", ""]);

// exports
exports.locals = {
	"container": "videos__container__2qYPc",
	"thumbnail-wrapper": "videos__thumbnail-wrapper__1tnmS",
	"thumbnailWrapper": "videos__thumbnail-wrapper__1tnmS",
	"next-button": "videos__next-button__1qqmh",
	"nextButton": "videos__next-button__1qqmh",
	"prev-button": "videos__prev-button__248HZ",
	"prevButton": "videos__prev-button__248HZ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/strip/components/videos/videos.styl
// module id = 2946
// module chunks = 1